/**
* DevExpress Dashboard (_helpers.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { DataItem } from '../model/data-item/data-item';
import { OlapDataSource } from '../model/data-sources/olap-data-source';
export function createDataMemberInfo(field, dataSource) {
    let dataMemberInfo = {
        name: dataSource instanceof OlapDataSource ? field.dataMember() : field.name(),
        displayName: ko.unwrap(field.displayName),
        isList: !field.isDataFieldNode(),
        specifics: field.isDataFieldNode() ? field.fieldType && DataItem.typesMap[field.fieldType()] || 'Default' :
            field.isDataSourceNode && field.isDataSourceNode() ||
                field.isDataTableNode && field.isDataTableNode() ||
                field.isExpressionsNode && field.isExpressionsNode() ||
                field.isList && field.isList() ? 'List' :
                'Default',
    };
    return {
        ...dataMemberInfo,
        hasItems: !field.isDataFieldNode(),
        field: field,
    };
}
